import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["openIcon", "closeIcon", "revealable"];
  static values = {
    revealableId: String,
    revealed: {
      type: Boolean,
      default: false,
    },
  };

  connect() {
    this.revealable = this.hasRevealableTarget
      ? this.revealableTarget
      : document.getElementById(this.revealableIdValue);
  }

  toggle() {
    this.revealable.classList.toggle("hidden");
    this.openIconTarget.classList.toggle("hidden");
    this.closeIconTarget.classList.toggle("hidden");
  }
}
